import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { GeoGate } from "@/components/GeoGate";
import { LoadingScreen } from "@/components/LoadingScreen";

export const Protected = ({ children, profileStep = false }) => {
  const { user, loading } = useAuth();

  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/" replace />;
  // Users with incomplete profiles are always redirected to profile completion
  if (!profileStep && !user.profile_completed) return <Navigate to="/complete-profile" replace />;
  if (profileStep && user.profile_completed) return <Navigate to="/circle" replace />;

  return <GeoGate>{children}</GeoGate>;
};
